import { Row } from 'app/design/primitives/box';

import { useDeviceWidth } from 'app/hooks/use-device-size';
import { PlaceholderLine } from 'app/overrides/rn-placeholder/PlaceholderLine';
import { PlaceholderMedia } from 'app/overrides/rn-placeholder/PlaceholderMedia';
import { ShineOverlay } from 'app/overrides/rn-placeholder/animations/ShineOverlay';
import React from 'react';
import { ScrollView, View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

function HorizontalListingCardSkeleton({ width }: { width: number }) {
  return (
    <View>
      <PlaceholderMedia
        style={{
          height: 120,
          width,
          borderRadius: 16,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      />
      <View
        style={{
          marginTop: -16,
          borderRadius: 16,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          backgroundColor: theme.colors['surface.tertiary-neutral'],
          width,
          paddingHorizontal: theme.spacing['spacing.general.x3'],
          paddingTop: theme.spacing['spacing.general.x2'],
          paddingBottom: theme.spacing['spacing.general.x4'],
        }}
      >
        <PlaceholderLine
          noMargin
          height={18}
          style={{ width: width * 0.72, marginBottom: theme.spacing['spacing.general.x1'] }}
        />
        <PlaceholderLine
          noMargin
          height={17}
          style={{ width: width * 0.42, marginBottom: theme.spacing['spacing.general.x2'] }}
        />
        <PlaceholderLine noMargin height={22} style={{ width: width * 0.6, borderRadius: 11 }} />
      </View>
    </View>
  );
}

export function HorizontalListingsSkeleton() {
  const w = useDeviceWidth();
  const imageWidth = Math.min(180, (w / 2) * 0.8);

  return (
    <View>
      <ShineOverlay>
        <PlaceholderLine
          noMargin
          height={20}
          style={{
            width: 160,
            borderRadius: 4,
            marginTop: 2,
            marginBottom: theme.spacing['spacing.general.x4'],
          }}
        />
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <Row gap="spacing.general.x4">
            {[0, 1, 2].map((i) => (
              <HorizontalListingCardSkeleton key={i} width={imageWidth} />
            ))}
          </Row>
        </ScrollView>
      </ShineOverlay>
    </View>
  );
}
